import React, { useEffect, useRef, useState } from "react";
import './Services.css';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import service1 from "./ServicesImages/purple blue capsule .png";
import service2 from "./ServicesImages/drug discovery 1.png";
import service3 from "./ServicesImages/impure synthesis 1.png";
import service4 from "./ServicesImages/Erlenmeyer flask and test tube for scientific experiments.png";
import service5 from "./ServicesImages/analytics icon.png";
import service6 from "./ServicesImages/robot hand.png";
import service7 from "./ServicesImages/Medicines and a digital thermometer.png";
import service8 from "./ServicesImages/satellites.png";
import contact_icon from '../Career/CareerImages/contact us icon.png';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';


import Marquee from "react-fast-marquee";

import Partner1 from './ServicesImages/cipla.png';
import Partner2 from './ServicesImages/neuland.png';
import Partner3 from './ServicesImages/mylan.png';
import Partner4 from './ServicesImages/natco.png';

// import EastIcon from '@mui/icons-material/East';
//top divs
// import DnaInPills from './ServicesImages/dnainpills.png';
import Clients1 from './ServicesImages/servicesaccountcount.png';
import Clients2 from './ServicesImages/servicesgrowth.png';
import Clients3 from './ServicesImages/serviceshappy.png';
import Clients4 from './ServicesImages/servicespeople.png';

import banner1 from './ServicesImages/banner1.png';
import banner2 from './ServicesImages/banner2.png';
import banner3 from './ServicesImages/banner3.png';
// import banner4 from './ServicesImages/banner4.png';
import banner5 from './ServicesImages/banner5.png';

import LaboratoryFlask from './ServicesImages/laboratoryflask.png';
import TestTube from './ServicesImages/servicestesttube.png';
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";




function Services() {
    const [openFaqIndex, setOpenFaqIndex] = useState(null);
    const renderOnlyOnce = useRef(false);
    const navigate = useNavigate();

    // New state for the random image functionality
    const [currentImage, setCurrentImage] = useState(banner1);
    const images = useMemo(() => [banner2, banner3], []);

    const toggleAnswer = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    useEffect(() => {
        // Ensure window scrolls to the top on first render
        if (!renderOnlyOnce.current) {
            window.scrollTo({ behavior: "instant", top: 0 });
            renderOnlyOnce.current = true;
        }

        // Random image logic
        const changeImage = () => {
            const randomIndex = Math.floor(Math.random() * images.length);
            setCurrentImage(images[randomIndex]);
        };

        // Set interval to change the image every 3 seconds (3000ms)
        const intervalId = setInterval(changeImage, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [images]);


    return (
        <>
            <div className="service-container">
                <Navbar />

                <div className="services-topdiv">
                    <div className="services-topdiv-inner">
                        <div className="services-topbanner-content">
                            <h1>Discover <span> <img src={currentImage} alt="Random Service Banner" /></span> our state-</h1>
                            <h2>of-the-art health</h2>
                            <h3>laboratory</h3>
                        </div>
                        <div className="services-topbanner-img1">
                            <img src={banner1} alt="banner1" />
                        </div>
                        <div className="services-topbanner-img2">
                            <img src={banner1} alt="banner1" />
                        </div>
                        <div className="services-topbanner-bigimg">
                            <img src={banner5} alt="banner1" />
                        </div>

                        {/* blur images */}
                        <div className="services-topdiv-blurimages"></div>
                        <div className="services-topdiv-blurimages1"></div>
                    </div>
                </div>

                {/* <div className="services-topdiv">
                    <div className="services-topdiv-inner">
                        <div className="services-topdiv-inner-first">
                            <h1>Excellence in Pharmaceutical Manufacturing</h1>
                            <p>At Arde’s Laboratories, we ensure every product meets the highest standards of quality, efficiency, and safety in manufacturing.</p>
                            <div className="services-topdiv-inner-first-explore">
                                <p>Explore More</p>
                                <EastIcon sx={{fontSize:20}}/>
                            </div>
                        </div>
                        <div className="services-topdiv-inner-second">
                            <div className="services-topdiv-inner-second-img">
                                <img src={DnaInPills} alt='dnainpills'/>
                            </div>
                        </div>
                        <div className="services-topdiv-blurimages"></div>
                        <div className="services-topdiv-blurimages1"></div>
                    </div>
                </div> */}

                {/* members ,clients */}
                <div className="services-members-clients">
                    <div className="services-members-clients-inner">
                        <div className="services-members-clients-first">
                            <div className="services-members-clients-each">
                                <div className="services-members-clients-each-img">
                                    <img src={Clients1} alt='clients' />
                                </div>
                                <div className="services-members-clients-each-content">
                                    <p>12+</p>
                                    <p>Our Members</p>
                                </div>
                            </div>
                            <div className="services-members-clients-each">
                                <div className="services-members-clients-each-img">
                                    <img src={Clients2} alt='clients' />
                                </div>
                                <div className="services-members-clients-each-content">
                                    <p>600+</p>
                                    <p>Happy Clients</p>
                                </div>
                            </div>
                            <div className="services-members-clients-each">
                                <div className="services-members-clients-each-img">
                                    <img src={Clients3} alt='clients' />
                                </div>
                                <div className="services-members-clients-each-content">
                                    <p>10+</p>
                                    <p>Years Experience</p>
                                </div>
                            </div>
                            <div className="services-members-clients-each">
                                <div className="services-members-clients-each-img">
                                    <img src={Clients4} alt='clients' />
                                </div>
                                <div className="services-members-clients-each-content">
                                    <p>200+</p>
                                    <p>Projects Done</p>
                                </div>
                            </div>
                        </div>
                        <div className="services-members-clients-second">
                            <div className="services-members-clients-images">
                                <div className="services-members-clients-images-box1"></div>
                                <div className="services-members-clients-images-box2"></div>
                                {/* images */}
                                <div className="services-members-clients-img1">
                                    <img src={LaboratoryFlask} alt='laboratory' />
                                </div>
                                <div className="services-members-clients-img2">
                                    <img src={TestTube} alt='laboratory' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* service page code starts from here */}
                <div className="services-servcons">
                    <h1>Services</h1>
                    <div class="services-grid">
                        <div class="service-card">
                            <img src={service1} alt="API Development & Manufacturing" />
                            <h2>API Development & Manufacturing</h2>
                            <p>Arde's Laboratories specializes in the production of Active Pharmaceutical Ingredients (APIs) while adhering to strict regulatory standards. This process includes the synthesis of drug impurities and creating technology transfer dossiers for a streamlined manufacturing transition.</p>
                        </div>

                        <div class="service-card">
                            <img src={service2} alt="Third-Party Manufacturing" />
                            <h2>Third-Party Manufacturing</h2>
                            <p>This service involves contract manufacturing of essential materials such as Key Starting Materials (KSMs), intermediates, and APIs for other pharmaceutical companies, helping them outsource production and focus on their core competencies.</p>
                        </div>

                        <div class="service-card">
                            <img src={service3} alt="Drug Discovery Services" />
                            <h2>Drug Discovery Services</h2>
                            <p>Arde’s offers synthetic and medicinal chemistry expertise to advance drug candidates, focusing on analogue design, synthesis, and development of key intermediates and building blocks crucial for new drug discoveries.</p>
                        </div>

                        <div class="service-card">
                            <img src={service4} alt="Process Development & Scale-Up" />
                            <h2>Process Development & Scale-Up</h2>
                            <p>This service covers the entire process from initial route scouting to pilot or commercial-scale synthesis for complex chemical processes, ensuring scalability and cost-efficiency.</p>
                        </div>

                        <div class="service-card">
                            <img src={service5} alt="Analytical Development & Validation" />
                            <h2>Analytical Development & Validation</h2>
                            <p>The laboratory develops methods to measure the stability of products to ensure readiness to meet cGMP standards, producing comprehensive regulatory compliance reports.</p>
                        </div>

                        <div class="service-card">
                            <img src={service6} alt="Technology Transfer" />
                            <h2>Technology Transfer</h2>
                            <p>This service ensures seamless technology transfer, including scaling up production with safety evaluations, process optimizations, and detailed checklists and SOPs.</p>
                        </div>

                        <div class="service-card">
                            <img src={service7} alt="Technology Transfer" />
                            <h2>Manufacturing Capabilities</h2>
                            <p>Arde’s offers flexible manufacturing options for APIs, peptides, and intermediates tailored to regulated markets. They accommodate various production volumes and complexities to meet diverse client needs.</p>
                        </div>

                        <div class="service-card">
                            <img src={service8} alt="Technology Transfer" />
                            <h2>Impurity Synthesis</h2>
                            <p>This involves the creation of process-related, degradation, and impurity profiles for drugs, helping ensure that all potential impurities are identified, quantified, and controlled.</p>
                        </div>
                    </div>

                    {/* blur images */}
                    <div className="services-inservices-blur1"></div>
                    <div className="services-inservices-blur2"></div>

                    <div className="services-inservices-blur3"></div>
                    <div className="services-inservices-blur4"></div>
                </div>
                {/* our partners */}
                <div className="service-ourpartner-container">
                    <h2 className="service-ourpartners-header">our Clients</h2>
                    <Marquee className="service-ourpartner-marquee" autoFill={true} pauseOnHover={true} gradient={true} gradientColor={'#d5f0ff'}>
                        <div className="service-ourpartners-each">
                            <img src={Partner1} alt='partner' />
                        </div>
                        <div className="service-ourpartners-each">
                            <img src={Partner2} alt='partner' />
                        </div>
                        <div className="service-ourpartners-each">
                            <img src={Partner3} alt='partner' />
                        </div>
                        <div className="service-ourpartners-each">
                            <img src={Partner4} alt='partner' />
                        </div>
                    </Marquee>
                </div>

                <div className="faq-section">
                    <h1>FAQs</h1>
                    <p>Find answers to the most common questions about our services, processes, and how we work to bring you safe, high-quality healthcare solutions.</p>
                    <div className="faq-container">
                        {[
                            {
                                question: "Can Arde's Laboratories handle third-party manufacturing requests?",
                                answer: "Absolutely! We offer comprehensive third-party manufacturing services, from Key Starting Materials (KSMs) to intermediates and Active Pharmaceutical Ingredients (APIs). Our team will work closely with you to ensure your product meets all regulatory standards and is manufactured efficiently. Contact us to discuss your manufacturing needs."
                            },
                            {
                                question: "What types of drug discovery services do you provide?",
                                answer: "Our drug discovery services include synthetic and medicinal chemistry, analogue design and synthesis, and the development of key intermediates and building blocks for drug candidate advancement. These services are designed to help our partners bring innovative treatments to market faster."
                            },
                            {
                                question: "How does the process development and scale-up work at Arde's Laboratories?",
                                answer: "We offer process development and scale-up services from initial route scouting to pilot and commercial-scale synthesis. Our process is tailored to ensure scalable, cost-effective, and environmentally sustainable methods for complex chemical processes. We work closely with clients to optimize each stage, making the transition from lab to market smooth and efficient."
                            },
                            {
                                question: "What quality standards do you follow for analytical development and validation?",
                                answer: "We adhere to cGMP (Current Good Manufacturing Practices) and develop stability-indicating methods as well as comprehensive stability programs. Our analytical services meet international regulatory standards, and we provide detailed reports to support regulatory submissions."
                            },
                            {
                                question: "How does your technology transfer process ensure a smooth scale-up?",
                                answer: "Our technology transfer process includes safety evaluations, process optimizations, and a comprehensive set of Standard Operating Procedures (SOPs). This ensures a seamless transition from development to production scale. Our team also offers support in regulatory documentation to meet global standards, helping clients achieve reliable and consistent results during scale-up."
                            },
                            {
                                question: "What’s involved in impurity synthesis and profiling at Arde’s?",
                                answer: "We specialize in creating detailed profiles of process-related, degradation, and impurity profiles for drugs. Our impurity synthesis service identifies and quantifies impurities, supporting both safety and regulatory compliance. This is crucial for clients working in regulated markets that require thorough impurity data."
                            }
                        ].map((faq, index) => (
                            <div key={index} className="faq-item">
                                <button className="faq-question" onClick={() => toggleAnswer(index)}>
                                    {faq.question}
                                    <span className="arrow">{openFaqIndex === index ? "▲" : "▼"}</span>
                                </button>
                                {openFaqIndex === index && (
                                    <div className="faq-answer">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>


                <div className="career-contact-con">
                    <div className="career-contact">
                        <div className="career-contact-cantent">
                            <h2>Questions? Get in Touch</h2>
                            <p>We’re here to help with any questions about your future at Arde’s Laboratories. Connect with us directly or explore our careers page to learn more.</p>
                            <button onClick={() => navigate('/contactus')}>Get In Touch <ArrowForwardRoundedIcon /></button>
                        </div>
                        <div className="career-contact-img">
                            <img src={contact_icon} alt="contact pic" />
                        </div>
                    </div>
                </div>
                {/* your code ends here */}
                <Footer />
            </div>
        </>
    );
}

export default Services;